// import React, { useState, useEffect } from "react";
// import { Table, Pagination, Input, Button, Toggle } from "rsuite";
// import { fetchPortofolios, updatePortofolio } from "../../../api/portofolioAPI";
// import { placeholderImage, isValidUrl } from "../../invalidImage";
// import ImageModal from "../../imageModal";
// import ModalPortofolio from "./addPortofolio";
// import ModalUpdatePortofolio from "./updatePortofolio";
// import { handleDeletePortofolio } from "./deletePortofolioHandler";

// const { Column, HeaderCell, Cell } = Table;

// const PortofolioTable = () => {
//   const [data, setData] = useState([]);
//   const [displayData, setDisplayData] = useState([]);
//   const [page, setPage] = useState(1);
//   const [limit, setLimit] = useState(10);
//   const [searchKeyword, setSearchKeyword] = useState("");
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
//   const [selectedPortofolio, setSelectedPortofolio] = useState(null);

//   const fetchData = async () => {
//     const portofoliosData = await fetchPortofolios();
//     setData(portofoliosData);
//     setDisplayData(portofoliosData.slice(0, limit));
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   useEffect(() => {
//     const start = (page - 1) * limit;
//     const end = start + limit;
//     setDisplayData(data.slice(start, end));
//   }, [page, limit, data]);

//   const handleChangePage = (page) => {
//     setPage(page);
//   };

//   const handleChangeLimit = (limit) => {
//     setLimit(limit);
//     setPage(1);
//   };

//   const handleSearch = (value) => {
//     setSearchKeyword(value);
//     if (value) {
//       const filteredData = data.filter((portofolio) =>
//         portofolio.name.toLowerCase().includes(value.toLowerCase())
//       );
//       setData(filteredData);
//       setPage(1);
//     } else {
//       fetchData();
//     }
//   };

//   const handleAddPortofolio = () => {
//     setIsModalOpen(true);
//   };

//   const handleUpdatePortofolio = (portofolio) => {
//     setSelectedPortofolio(portofolio);
//     setIsUpdateModalOpen(true);
//   };

//   const handleToggleStatus = async (portofolio) => {
//     const updatedStatus = portofolio.status === 1 ? 0 : 1;
//     const updatedPortofolio = { ...portofolio, status: updatedStatus };

//     try {
//       await updatePortofolio(portofolio.id, updatedPortofolio);
//       setData((prevData) =>
//         prevData.map((item) =>
//           item.id === portofolio.id ? { ...item, status: updatedStatus } : item
//         )
//       );
//     } catch (error) {
//       console.error("Failed to update status:", error);
//     }
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setIsUpdateModalOpen(false);
//   };

//   return (
//     <div className="flex-1 h-full overflow-y-auto overflow-x-hidden p-4">
//       <div className="flex justify-between items-center mb-4">
//         <h2>Portofolio Table</h2>
//         <Button appearance="primary" onClick={handleAddPortofolio}>
//           Tambah Portofolio
//         </Button>
//       </div>
//       <div className="mb-4">
//         <Input
//           placeholder="Search..."
//           value={searchKeyword}
//           onChange={handleSearch}
//         />
//       </div>
//       <Table
//         autoHeight
//         data={displayData}
//         onRowClick={(rowData) => {
//           console.log(rowData);
//         }}
//         rowHeight={100}
//       >
//         <Column width={60} align="center" fixed>
//           <HeaderCell>No</HeaderCell>
//           <Cell>
//             {(rowData, rowIndex) => {
//               const serialNumber = (page - 1) * limit + rowIndex + 1;
//               return <span>{serialNumber}</span>;
//             }}
//           </Cell>
//         </Column>

//         <Column width={100}>
//           <HeaderCell>Image</HeaderCell>
//           <Cell>
//             {(rowData) => (
//               <ImageModal
//                 imageUrl={
//                   isValidUrl(rowData.img) ? rowData.img : placeholderImage
//                 }
//               />
//             )}
//           </Cell>
//         </Column>

//         <Column width={200}>
//           <HeaderCell>Name</HeaderCell>
//           <Cell dataKey="name" className="py-2" />
//         </Column>

//         <Column width={200}>
//           <HeaderCell>Type</HeaderCell>
//           <Cell dataKey="type" className="py-2" />
//         </Column>

//         <Column width={150}>
//           <HeaderCell>Link</HeaderCell>
//           <Cell>
//             {(rowData) => (
//               <a href={rowData.link} target="_blank" rel="noopener noreferrer">
//                 {rowData.link}
//               </a>
//             )}
//           </Cell>
//         </Column>

//         <Column width={100}>
//           <HeaderCell>Status</HeaderCell>
//           <Cell>
//             {(rowData) => (
//               <Toggle
//                 checked={rowData.status === 1}
//                 size="sm"
//                 onChange={() => handleToggleStatus(rowData)}
//               />
//             )}
//           </Cell>
//         </Column>

//         <Column width={150}>
//           <HeaderCell>Action</HeaderCell>
//           <Cell>
//             {(rowData) => {
//               const handleDelete = () => {
//                 handleDeletePortofolio(rowData.id, data, setData);
//               };

//               const handleEdit = () => {
//                 handleUpdatePortofolio(rowData);
//               };

//               return (
//                 <span>
//                   <a onClick={handleEdit}> Edit </a> |{" "}
//                   <a onClick={handleDelete}> Remove </a>
//                 </span>
//               );
//             }}
//           </Cell>
//         </Column>
//       </Table>
//       <div className="flex justify-end mt-4">
//         <Pagination
//           prev
//           next
//           first
//           last
//           ellipsis
//           boundaryLinks
//           maxButtons={5}
//           size="xs"
//           layout={["total", "-", "limit", "|", "pager"]}
//           total={data.length}
//           limitOptions={[5, 10, 20, 50]}
//           limit={limit}
//           activePage={page}
//           onChangePage={handleChangePage}
//           onChangeLimit={handleChangeLimit}
//         />
//       </div>

//       {/* Modal untuk tambah portofolio */}
//       {isModalOpen && <ModalPortofolio closeModal={closeModal} />}

//       {/* Modal untuk update portofolio */}
//       {isUpdateModalOpen && selectedPortofolio && (
//         <ModalUpdatePortofolio
//           portofolio={selectedPortofolio}
//           onClose={closeModal}
//         />
//       )}
//     </div>
//   );
// };

// export default PortofolioTable;


import React, { useState, useEffect } from "react";
import { Table, Pagination, Input, Button, Toggle, InputGroup } from "rsuite";
import SearchIcon from "@rsuite/icons/Search"; 
import PlusIcon from "@rsuite/icons/Plus";
import EditIcon from "@rsuite/icons/Edit";
import TrashIcon from "@rsuite/icons/Trash";
import { fetchPortofolios, updatePortofolio, togglePortofolioFeatured } from "../../../api/portofolioAPI";
import { placeholderImage, isValidUrl } from "../../invalidImage";
import ImageModal from "../../imageModal";
import ModalPortofolio from "./addPortofolio";
import ModalUpdatePortofolio from "./updatePortofolio";
import { handleDeletePortofolio } from "./deletePortofolioHandler";

const { Column, HeaderCell, Cell } = Table;

const PortofolioTable = () => {
  const [data, setData] = useState([]);
  const [displayData, setDisplayData] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [selectedPortofolio, setSelectedPortofolio] = useState(null);

  const fetchData = async () => {
    const portofoliosData = await fetchPortofolios();
    setData(portofoliosData);
    setDisplayData(portofoliosData.slice(0, limit));
  };

  useEffect(() => {
    fetchData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const start = (page - 1) * limit;
    const end = start + limit;
    setDisplayData(data.slice(start, end));
  }, [page, limit, data]);

  const handleChangePage = (page) => setPage(page);

  const handleChangeLimit = (limit) => {
    setLimit(limit);
    setPage(1);
  };

  const handleSearch = (value) => {
    setSearchKeyword(value);
    if (value) {
      const filteredData = data.filter((portofolio) =>
        portofolio.name.toLowerCase().includes(value.toLowerCase())
      );
      setData(filteredData);
      setPage(1);
    } else {
      fetchData();
    }
  };

  const handleAddPortofolio = () => setIsModalOpen(true);

  const handleUpdatePortofolio = (portofolio) => {
    setSelectedPortofolio(portofolio);
    setIsUpdateModalOpen(true);
  };

  const handleToggleStatus = async (portofolio) => {
    const updatedStatus = portofolio.status === 1 ? 0 : 1;
    const updatedPortofolio = { ...portofolio, status: updatedStatus };
    try {
      await updatePortofolio(portofolio.id, updatedPortofolio);
      setData((prevData) =>
        prevData.map((item) =>
          item.id === portofolio.id ? { ...item, status: updatedStatus } : item
        )
      );
    } catch (error) {
      console.error("Failed to update status:", error);
    }
  };

  const handleToggleFeatured = async (portofolio) => {
    try {
      const res = await togglePortofolioFeatured(portofolio.id);
      setData((prevData) =>
        prevData.map((item) =>
          item.id === portofolio.id ? { ...item, is_featured: res.is_featured } : item
        )
      );
    } catch (error) {
      console.error("Failed to toggle featured:", error);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsUpdateModalOpen(false);
  };

  return (
    <div className="min-h-screen bg-white p-8">
      {/* Header Section - Full White, No Container */}
      <div className="mb-8 flex flex-col md:flex-row md:items-end justify-between gap-6">
        <div className="space-y-1">
          <h2 className="text-3xl font-extrabold text-gray-900 tracking-tight">
            Portfolio Management
          </h2>
          <p className="text-gray-500 text-base">
            Manage and showcase your best projects to the world.
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <InputGroup className="w-full sm:w-80 !border-gray-200 !shadow-none focus-within:!border-blue-500 transition-all">
            <InputGroup.Addon className="bg-transparent">
              <SearchIcon />
            </InputGroup.Addon>
            <Input
              placeholder="Search project name..."
              value={searchKeyword}
              onChange={handleSearch}
              className="!bg-transparent"
            />
          </InputGroup>
          
          <Button 
            color="blue" 
            appearance="primary" 
            startIcon={<PlusIcon />}
            onClick={handleAddPortofolio}
            className="!rounded-md !px-6 !py-2.5 font-semibold transition-all hover:brightness-110 active:scale-95"
          >
            Add Portfolio
          </Button>
        </div>
      </div>

      {/* Table Section - Flat Design */}
      <div className="border-t border-gray-100">
        <Table
          autoHeight
          data={displayData}
          rowHeight={85}
          hover={true}
          className="!border-none"
        >
          <Column width={60} align="center" fixed>
            <HeaderCell className="!bg-transparent font-bold text-gray-400 uppercase text-[11px] tracking-widest">No</HeaderCell>
            <Cell>
              {(rowData, rowIndex) => (
                <span className="text-gray-400 font-medium">
                  {(page - 1) * limit + rowIndex + 1}
                </span>
              )}
            </Cell>
          </Column>

          <Column width={120} align="center">
            <HeaderCell className="!bg-transparent font-bold text-gray-400 uppercase text-[11px] tracking-widest">Preview</HeaderCell>
            <Cell>
              {(rowData) => (
                <div className="flex justify-center items-center h-full">
                  <div className="w-20 h-14 rounded-lg overflow-hidden bg-gray-50 border border-gray-100 group transition-all">
                    <ImageModal
                      imageUrl={isValidUrl(rowData.img) ? rowData.img : placeholderImage}
                    />
                  </div>
                </div>
              )}
            </Cell>
          </Column>

          <Column width={300} flexGrow={1}>
            <HeaderCell className="!bg-transparent font-bold text-gray-400 uppercase text-[11px] tracking-widest">Project Details</HeaderCell>
            <Cell>
              {(rowData) => (
                <div className="flex flex-col justify-center h-full">
                  <span className="font-bold text-gray-800 text-base leading-tight">{rowData.name}</span>
                  <div className="flex items-center gap-2 mt-1.5">
                    <span className="text-[10px] font-bold px-2 py-0.5 bg-gray-100 text-gray-600 rounded uppercase tracking-wider">
                      {rowData.type || "General"}
                    </span>
                  </div>
                </div>
              )}
            </Cell>
          </Column>

          <Column width={200}>
            <HeaderCell className="!bg-transparent font-bold text-gray-400 uppercase text-[11px] tracking-widest">Direct Link</HeaderCell>
            <Cell>
              {(rowData) => (
                <a 
                  href={rowData.link} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:text-blue-700 font-medium text-sm truncate block transition-colors"
                >
                  {rowData.link}
                </a>
              )}
            </Cell>
          </Column>

          <Column width={100} align="center">
            <HeaderCell className="!bg-transparent font-bold text-gray-400 uppercase text-[11px] tracking-widest">Status</HeaderCell>
            <Cell>
              {(rowData) => (
                <div className="flex justify-center items-center h-full">
                   <Toggle
                    checked={rowData.status === 1}
                    size="sm"
                    onChange={() => handleToggleStatus(rowData)}
                  />
                </div>
              )}
            </Cell>
          </Column>

          <Column width={110} align="center">
            <HeaderCell className="!bg-transparent font-bold text-gray-400 uppercase text-[11px] tracking-widest">Featured</HeaderCell>
            <Cell>
              {(rowData) => (
                <div className="flex justify-center items-center h-full">
                  <button
                    onClick={() => handleToggleFeatured(rowData)}
                    title="Toggle featured"
                    className={`w-8 h-8 rounded-lg flex items-center justify-center transition-all duration-200 ${
                      rowData.is_featured
                        ? "bg-yellow-100 text-yellow-600 hover:bg-yellow-200"
                        : "bg-gray-100 text-gray-400 hover:bg-gray-200"
                    }`}
                  >
                    <svg className="w-4 h-4" fill={rowData.is_featured ? "currentColor" : "none"} stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                    </svg>
                  </button>
                </div>
              )}
            </Cell>
          </Column>

          <Column width={150} align="right" fixed="right">
            <HeaderCell className="!bg-transparent font-bold text-gray-400 uppercase text-[11px] tracking-widest px-4">Actions</HeaderCell>
            <Cell className="px-4">
              {(rowData) => (
                <div className="flex gap-2 justify-end items-center h-full">
                  <button 
                    onClick={() => handleUpdatePortofolio(rowData)}
                    className="p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-md transition-all"
                  >
                    <EditIcon />
                  </button>
                  <button 
                    onClick={() => handleDeletePortofolio(rowData.id, data, setData)}
                    className="p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-md transition-all"
                  >
                    <TrashIcon />
                  </button>
                </div>
              )}
            </Cell>
          </Column>
        </Table>

        {/* Pagination Section - Simple Bottom Line */}
        <div className="py-6 mt-2 border-t border-gray-50 flex flex-col sm:flex-row justify-between items-center gap-4">
          <span className="text-sm text-gray-400 font-medium">
            Showing <span className="text-gray-900">{displayData.length}</span> of <span className="text-gray-900">{data.length}</span> items
          </span>
          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            maxButtons={5}
            size="sm"
            layout={["limit", "|", "pager"]}
            total={data.length}
            limitOptions={[10, 20, 50]}
            limit={limit}
            activePage={page}
            onChangePage={handleChangePage}
            onChangeLimit={handleChangeLimit}
            className="!m-0"
          />
        </div>
      </div>

      {/* Modal Tetap Ada (untuk interaksi tambah/edit) */}
      {isModalOpen && <ModalPortofolio closeModal={closeModal} />}
      {isUpdateModalOpen && selectedPortofolio && (
        <ModalUpdatePortofolio
          portofolio={selectedPortofolio}
          onClose={closeModal}
        />
      )}
    </div>
  );
};

export default PortofolioTable;